import { useEffect, useRef, useState } from "react";
import ArrowBis from "../../components/assets/ArrowBis";
import ScrollReveal from "scrollreveal";
import { useMediaQuery } from "react-responsive";

export default function DoubleArrowBackground(
    {
        children
    }
) {
    const [arrowAnimated, setArrowAnimated] = useState(false);
    const isMobile = useMediaQuery({
        query: "(max-width: 780px)"
    });

    const container = useRef(null);
    useEffect(() => {
        ScrollReveal().reveal(container.current, {
            opacity: 1,
            afterReveal: () => {
                setArrowAnimated(true);
            },
            viewFactor: 0.5
        })
    }, []);
    return (
        <div
            className="min-h-[890px] py-[8rem] mobile:min-h-[700px] w-full"
            style={{
                background: `linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)), url('${isMobile ? "https://zoeil.yanisallali.com/wp-content/uploads/2024/10/background_responsive.png" : "https://zoeil.yanisallali.com/wp-content/uploads/2024/10/yanis-et-logan.jpg"}') ${isMobile ? "bottom" : "top"} center / ${isMobile ? "150%" : "cover"} no-repeat`
            }}
            ref={container}>
            <div className="w-fit mx-auto relative">
                {children ? children : <div className="min-w-[300px]"></div>}
                <div className="flex absolute -left-[10dvw] top-0 gap-[2rem] -translate-x-full tablet:flex-row-reverse tablet:left-0 tablet:top-[8rem] tablet:translate-x-0">
                    <div className="gochi-hand-regular text-[2.33rem]">
                        Yanis
                    </div>
                    <div className="w-[7.875rem] aspect-square tablet:-scale-x-[1]">
                        <ArrowBis animated={arrowAnimated} />
                    </div>
                </div>
                <div className="flex absolute left-full top-0 translate-x-[20dvw] flex-col items-end tablet:translate-x-0 tablet:left-auto tablet:top-[8rem] tablet:right-0">
                    <div className="gochi-hand-regular text-[2.33rem]">
                        Logan
                    </div>
                    <div className="w-[7.875rem] aspect-square rotate-[90deg] tablet:-scale-y-[1]">
                        <ArrowBis animated={arrowAnimated} />
                    </div>
                </div>
            </div>
        </div>
    )
}